import Loadable from 'react-loadable'
import LoadingIndicatorFull from './LoadingIndicatorFull.js'

const LoadableResourcesHome = Loadable({
  loader: () => import('./ResourcesHomeContainer.js'),
  loading: LoadingIndicatorFull,
})

export default LoadableResourcesHome

